import { COLORS } from "@treelab/panda";

export const CHART_COLORS = [
  "#577eff",
  "#f76368",
  "#ffc561",
  "#33d2b8",
  "#837bff",
  "#ff5baa",
  "#ff945f",
  "#bb7aef",
  "#6ed2f4",
  "#55d276"
];

export const getColors = (index: number, value?: string) => {
  if (value === "" || (value && /^empty/.test(value))) return COLORS.greyLight1;
  return CHART_COLORS[index % CHART_COLORS.length];
}